import axios from 'axios';
export default {
    postAnalytics (data) {
        axios.post('/api/info', data);
    },
    postAnalyticSync (analyticsData, token) {
        var client=new XMLHttpRequest;
        client.open("POST","/api/info/", false);
        client.setRequestHeader("content-type","application/json");
        client.setRequestHeader("Authorization","Bearer " + token);
        client.send(JSON.stringify(analyticsData));

    }
};
